<template>
  <fragment>
    <b-button
      v-if="row.detailsShowing && !row.item.notes.edit"
      class="border mr-1 edit-notes"
      @click="enableNotesEdit(row.item.notes)"
    >
      Edit
    </b-button>
    <b-button
      v-else-if="row.detailsShowing && row.item.notes.edit"
      :disabled="!row.item.notes.updated || row.item.notes.saving"
      class="border mr-1 save-notes"
      @click="saveNotes(row.item)"
    >
      Save
      <font-awesome-icon
        v-if="row.item.notes.saving"
        :spin="true"
        :icon="['fas', 'spinner']"
        class="icon alt"
      />
      <font-awesome-icon v-else :icon="['fas', 'check']" />
    </b-button>
    <b-button
      v-if="!row.detailsShowing"
      :class="row.item.notes.note ? 'border border-success' : 'border'"
      @click="row.toggleDetails"
    >
      <font-awesome-icon
        :class="row.item.notes.note ? 'highlighted-notes-icon' : ''"
        :icon="['fas', 'note-sticky']"
      />
    </b-button>
    <b-button
      v-else
      class="cancel-btn"
      @click="toggleDetailsOrCancel(row)"
    >
      <font-awesome-icon :icon="['fas', 'xmark']" />
    </b-button>
  </fragment>
</template>

<script>
export default {
    name: 'CrisisCasesNotes',
    props: {
      row: {
        type: Object,
        require: true,
        default: () => null,
      },
    },
    methods: {
      enableNotesEdit(notes) {
        notes.edit = true;
      },
      toggleDetailsOrCancel(row) {
        if (row.item.notes.edit) {
          row.item.notes.note = row.item.notes.initialNote;
          row.item.notes.edit = false;
          row.item.notes.updated = false;
        } else {
          row.toggleDetails();
        }
      },
      saveNotes(item) {
        item.notes.saving = true;
        this.$emit('input', item);
      }
    }
}
</script>

<style lang="scss">
.save-notes {
  background-color: green;
}

.highlighted-notes-icon {
  color: $green;
}
.cancel-btn {
  background-color: $red;
  &:hover, &:focus {
    background-color: $red;
  }
}
</style>
